import { Button } from '@mui/material';

/**
 * @typedef {Object} NavigationButtonProps
 * @property {string} label - Button label text
 * @property {() => void} onClick - Click handler function
 * @property {string} [className] - Additional CSS classes
 * @property {Object} [sx] - Additional Material-UI sx props
 * @property {boolean} [isMobile] - Whether the button is in mobile context
 */

/**
 * Navigation Button component
 *
 * A reusable navigation button with consistent styling for the RSM Collective
 * header navigation. Supports both desktop and mobile contexts.
 *
 * @param {NavigationButtonProps} props - Component props
 * @returns {JSX.Element} Navigation button
 */
function NavigationButton({
  label,
  onClick,
  className,
  sx = {},
  isMobile = false,
}) {
  return (
    <Button
      color="inherit"
      onClick={onClick}
      className={className}
      sx={{
        px: isMobile ? 2 : 3,
        py: isMobile ? 1 : 1.5,
        fontSize: '1rem',
        fontWeight: 500,
        color: 'white',
        textTransform: 'none',
        borderRadius: isMobile ? 1 : 2,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          color: 'primary.main',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
        ...sx,
      }}
    >
      {label}
    </Button>
  );
}

export default NavigationButton;
